import type {Module} from "vuex";
import type {RootState} from "@/store/types";

// Checkout field delivered by the platform (see docs/*.json for the checkout_config schema)
export interface CheckoutConfigItem {
    container?: string
    [key: string]: unknown
}

export interface ConfigUserCheckoutState {
    config: CheckoutConfigItem[]
}

const checkout: Module<ConfigUserCheckoutState, RootState> = {
    namespaced: true,
    state: {
        config: []
    },
    getters: {
        config: (state): CheckoutConfigItem[] => state.config,
        configBeforeAddress: (state): CheckoutConfigItem[] => state.config.filter(item => "beforeAddress" === item.container),
        configAfterAddress: (state): CheckoutConfigItem[] => state.config.filter(item => "afterAddress" === item.container)
    },
    mutations: {
        setConfig: (state, config: CheckoutConfigItem[]) => state.config = config
    },
    actions: {
        setConfig(context, config: CheckoutConfigItem[]) {

            context.commit("setConfig", config);
        },
        clear(context) {

            context.commit("setConfig", []);
        }
    }
}

export default checkout
